export default "__VITE_ASSET__0f087e34__"